@if (data) {
  <div
    class="pot-block-lottie"
    #blockLottie
    [ngClass]="[alignment(), customCssClasses]"
    [attr.data-aos]="data.aosAnimation?.type"
    [attr.data-aos-offset]="aosAnimationOffset"
    [attr.data-aos-delay]="data.aosAnimation?.delay"
  >
    <div [style.width]="width">
      @if (options) {
        <ng-lottie
          [height]="height ?? null"
          [options]="options"
          (animationCreated)="animationCreated($event)"
        ></ng-lottie>
      }
    </div>
  </div>
}
